import { motion } from "framer-motion";
import SVG from "react-inlinesvg";
import { cn } from "src/lib/cn";
import ImageShimmerOverlay from "./ImageShimmerOverlay";
import type { ItemSaveStatus } from "./lib/types";

const CHECK_POP = { type: "spring" as const, stiffness: 500, damping: 25 };

export default function ImageSavingOverlay({ status, className }: { status: ItemSaveStatus; className?: string }) {
  if (status === "saving") {
    return <ImageShimmerOverlay className={className} />;
  }

  if (status === "error") {
    return (
      <div
        className={cn(
          "absolute inset-0 z-20 flex items-center justify-center overflow-hidden rounded-[inherit] bg-[color-mix(in_srgb,var(--danger-color)_50%,transparent)]",
          className,
        )}
        aria-hidden="true"
      >
        <motion.span
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={CHECK_POP}
          className="flex h-9 w-9 items-center justify-center rounded-full bg-app-danger-color shadow-default"
        >
          <SVG
            src="/assets/warning.svg"
            width={18}
            height={18}
            className="[&_path]:fill-white"
            aria-hidden="true"
          />
        </motion.span>
      </div>
    );
  }

  return (
    <div
      className={cn(
        "absolute inset-0 z-20 flex items-center justify-center overflow-hidden rounded-[inherit] bg-[color-mix(in_srgb,var(--success-color)_50%,transparent)]",
        className,
      )}
      aria-hidden="true"
    >
      <motion.span
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={CHECK_POP}
        className="flex h-9 w-9 items-center justify-center rounded-full bg-app-success-color shadow-[0_3px_8px_rgba(0,0,0,0.35)]"
      >
        <SVG
          src="/assets/check-tick.svg"
          width={18}
          height={18}
          className="[&_path]:fill-white"
          aria-hidden="true"
        />
      </motion.span>
    </div>
  );
}
